import { render } from "./message.vue?vue&type=template&id=9683077c"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=9683077c&lang=less"

import exportComponent from "F:\\code\\suplasercut\\suplasercut-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__